export {
  TemplateType,
  isTemplateType,
  getTemplateTypes,
  getTemplateTypeDisplayValue,
};
// export { TemplateType }

type TemplateType = "NORMAL" | "GENERAL" | "FORMAT" | "UNKNOWN";

const templateTypeKeys: TemplateType[] = [
  "NORMAL",
  "GENERAL",
  "FORMAT",
  "UNKNOWN",
];

const isTemplateType = (value: string): value is TemplateType => {
  return templateTypeKeys.indexOf(value as TemplateType) > -1;
};

const getTemplateTypes = () => {
  return [...templateTypeKeys];
};

const getTemplateTypeDisplayValue = (key: TemplateType): string => {
  switch (key) {
    case "FORMAT": {
      return "General Format";
    }
    case "GENERAL": {
      return "General Classification";
    }
    case "NORMAL": {
      return "Specific";
    }
    case "UNKNOWN": {
      return "Unknown";
    }
    default: {
      throw new Error(`TemplateType ${key} Is Not Valid`);
    }
  }
};
